import { ref } from 'vue';
import { defineStore } from 'pinia';
import axios from 'axios';

export const useKaleadicalStore = defineStore('kaleadicals', () => {
    const all = ref(null);
    const active = ref({});

    const actions = {
        search: (params) => axios.get('/api/v1/kaleadicals', { params }),
        storeKaleadical: (params) => axios.post('/api/v1/kaleadicals', params),
        updateKaleadical: (params) => axios.patch('/api/v1/kaleadicals/' + params.hash, params),
        storeHabits: (params) => axios.patch('/api/v1/kaleadicals/' + params.hash+'/track', params),
    };

    return {
        all,
        ...actions,
        active,
    };
});
